import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { AUTOMATION_TRANSACTIONS } from './actions';
import { IMPORT_STATS_TABLE } from 'cargo-chief-commons';

export const reducers = createReducer(
	initialState,
	on(AUTOMATION_TRANSACTIONS.TRANSACTIONS_LIST.GET, (state) => ({ ...state, loading: true })),
	on(AUTOMATION_TRANSACTIONS.TRANSACTIONS_LIST.SUCCESS, (state, action) => ({
		...state,
		loading: false,
		transactionsList: IMPORT_STATS_TABLE(action.content, state.usersList),
		total: action.totalElements,
	})),
	on(AUTOMATION_TRANSACTIONS.TRANSACTIONS_LIST.FAILURE, (state, action) => ({
		...state,
		loading: false,
	})),
	on(AUTOMATION_TRANSACTIONS.USERS_LIST.SET, (state, action) => ({
		...state,
		usersList: action.usersList,
	})),

	on(AUTOMATION_TRANSACTIONS.STATS.TRANSACTIONS_COUNT.SUCCESS, (state, action) => ({
		...state,
		totalTransactions: action.data,
	})),
	on(AUTOMATION_TRANSACTIONS.STATS.THIS_MONTH.SUCCESS, (state, action) => ({
		...state,
		transactionsThisMonth: action.data,
	})),
	on(AUTOMATION_TRANSACTIONS.STATS.PRICING.SUCCESS, (state, action) => ({
		...state,
		transactionsUsedForPricing: action.data,
	})),
	on(AUTOMATION_TRANSACTIONS.IMPORT_STAT.UPDATE, (state, action) => ({
		...state,
		transactionsList: state.transactionsList.map((importStatsTable) => {
			const { importStat } = action;
			if (importStatsTable.id == action.importStat.id) {
				return IMPORT_STATS_TABLE([importStat], state.usersList)[0];
			}
			return importStatsTable;
		}),
	})),
	on(AUTOMATION_TRANSACTIONS.IMPORT_STAT.ADD, (state, action) => ({
		...state,
		transactionsList: [
			...IMPORT_STATS_TABLE([action.importStat], state.usersList),
			...state.transactionsList.filter((rfp) => rfp.filename != action.importStat.filename),
		],
	}))
);
